import InvestmentDetails from './InvestmentDetails'
import Button from '../../../../../components/ui-components/Button'
import { useNavigate } from 'react-router-dom'
import { useMetaDataContext } from '../../../../../state-management/contexts/MetaDataContext'
import { useQuery } from '@tanstack/react-query'
import { fetchMFExecutionData } from '../../../../../repository/mfExecution'
import { MFExecutionData } from '../../../../../types/mf-execution.types'
import { InvestmentDataType } from '../../../types/investmentApi.types'
import { useMemo } from 'react'
import TaxLiabilityV2 from '../tax/TaxLiabilityV2'

export default function InvestmentBody({
  investmentDataOverride,
  temporaryFamilyAccessToken
}: {
  investmentDataOverride: InvestmentDataType
  temporaryFamilyAccessToken: string
}) {
  const navigate = useNavigate()
  const { isin, data: metadata } = useMetaDataContext()

  useQuery<MFExecutionData>({
    queryKey: ['mfExecutionData', isin],
    queryFn: () => fetchMFExecutionData(isin ?? '')
  })

  const url2 = useMemo(
    () =>
      `/mutual-fund/${isin}/transactions-v2?fundName=${encodeURIComponent(metadata?.fundDetails?.fundName ?? '')}${
        temporaryFamilyAccessToken
          ? `&temporaryFamilyAccessToken=${encodeURIComponent(temporaryFamilyAccessToken)}`
          : ''
      }`,
    [isin, metadata, temporaryFamilyAccessToken]
  )

  return (
    <div className='flex flex-col w-full pt-[11px] pb-5'>
      <InvestmentDetails investmentDataOverride={investmentDataOverride} />
      <div className='w-full pt-4'>
        <TaxLiabilityV2 temporaryFamilyAccessToken={temporaryFamilyAccessToken} />
      </div>

      <div className='pt-4 w-full animate-fade-150'>
        <Button
          isFullWidth
          buttonClassName='h-[48px] text-[#28393E] text-[14px] font-[500]'
          onClick={() => navigate(url2)}
        >
          View Transactions
        </Button>
      </div>
    </div>
  )
}
